export function getTableKey(tableKind, displayMode, keyAddition = '') {
  return `${tableKind}_${displayMode}_${window.location.pathname}_${keyAddition}`;
}